(function () {
  function initFaq(root) {
    const searchInput = root.querySelector('[data-faq-search]');
    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const categories = Array.from(root.querySelectorAll('.elx-faq__category'));
    const emptyState = root.querySelector('[data-faq-empty]');

    if (!searchInput || !items.length) return;

    function syncVisibility() {
      const query = searchInput.value.trim().toLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const text = item.textContent.toLowerCase();
        const match = !query || text.includes(query);
        item.hidden = !match;
        if (match) visibleCount += 1;
      });

      categories.forEach((heading) => {
        let sibling = heading.nextElementSibling;
        let hasVisible = false;

        while (sibling && !sibling.classList.contains('elx-faq__category')) {
          if (sibling.matches('[data-faq-item]') && !sibling.hidden) {
            hasVisible = true;
            break;
          }
          sibling = sibling.nextElementSibling;
        }

        heading.hidden = !hasVisible;
      });

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }
    }

    searchInput.addEventListener('input', syncVisibility);

    if (window.location.hash) {
      const target = root.querySelector(window.location.hash);
      if (target) {
        const nextItem = target.nextElementSibling;
        if (nextItem && nextItem.matches('[data-faq-item]')) {
          nextItem.open = true;
        }
      }
    }

    syncVisibility();
  }

  function init() {
    document.querySelectorAll('[data-elx-faq]').forEach((root) => {
      if (root.dataset.elxFaqBound === 'true') return;
      root.dataset.elxFaqBound = 'true';
      initFaq(root);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
